import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";

import { createGenericQueueSchema } from "../../schema";

export default addKeyToFieldsRecursively(createGenericQueueSchema());
